/**
 * English - `tipsSignature`: the ⓘ explanations beside the signature settings
 * fields. One key per field, passed as the field's `info`.
 * Conventions: see `common.ts`.
 */
const tipsSignature: Record<string, string> = {
  invoice_enabled:
    'When on, new invoices show your signature image, name and designation above "Authorised Signatory". When off, invoices show the plain block with your business name only.',
  image:
    'A picture of your signature. Upload a PNG, JPG or WebP, or draw it here. A transparent background looks best. It is shrunk to fit a small box on the invoice.',
  signatory_name:
    'The name of the person who signs, printed under the signature. Optional, up to 80 characters. Example: Asha Rao',
  designation:
    'The signatory’s role in the business, printed under their name. Optional, up to 80 characters. Example: Proprietor',
  email_enabled:
    'When on, a signature is added to the emails your shop sends customers, such as order updates. When off, emails are sent exactly as before.',
  email_sign_off:
    'The closing line just before your name. Optional, up to 80 characters. Example: Warm regards,',
  email_sender_name:
    'The name the email is signed with. Leave blank to use your shop name. Up to 80 characters. Example: Asha from Kurta & Co',
  email_designation:
    'A role or team shown under the sender name. Optional, up to 80 characters. Example: Customer care',
  email_show_image:
    'Adds the signature image from the Invoice tab under your sign-off. Only in emails that support pictures; plain-text emails skip it.',
  email_show_phone:
    'Adds your phone number under the signature so customers can call you.',
  phone:
    'The number to show. Leave blank to use the phone number in your business details. Up to 20 characters. Example: +91 98765 43210',
  email_show_email:
    'Adds your contact email address under the signature.',
  contact_email:
    'The email address to show. Leave blank to use the one in your business details. Example: hello@kurtaandco.in',
  email_show_website:
    'Adds your website address under the signature.',
  website:
    'The website to show, starting with https://. Leave blank to use your store address. Example: https://kurtaandco.in',
};

export default tipsSignature;
